module.exports = __webpack_public_path__ + "static/media/yellow-bg-square.c7567ad8.webp";